import React from 'react';
import './Footer.css'

function Footer() {
    return (
        <div className='footer'>
            <p>© 2021 Golgoole | Long Live Google - Project by <a href="https://t.me/uAnon" > Arefat Hyeredin</a> </p>
            <h5><p>Business · How search works · About</p>Privacy · Terms · Setting </h5>
        </div>
    )
}

export default Footer
